import { createSlice } from "@reduxjs/toolkit";

const reportSlice = createSlice({
  name: "report",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    setReportData: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearReport: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const { setReportData, setLoading, setError, clearReport } =
  reportSlice.actions;
export default reportSlice.reducer;
